import _Field from "redux-form/es/Field";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { maxLength, minLength, required } from 'swag-client-common/utils/redux-form-validators';
import { COUNTRY_CODES } from 'swag-common/constants/shipping.constants';
import { FormRow } from '../form-row';
import { FormInput } from '../form-input';
import StyledInput from '../styled-input';
import responsiveClasses from '../payment-form-styling/payment-form-styling.scss';
import fixedClasses from '../payment-form-styling/payment-form-styling-fixed.scss';
import { FormCountryPicker } from '../form-country-picker';
import { FormStatePicker } from '../form-state-picker';
export class PaymentDetailsBillingAddressForm extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleCountryChange", (_, value, previousValue) => {
      if (value !== previousValue && [value, previousValue].includes(COUNTRY_CODES.US)) {
        const {
          resetState
        } = this.props;
        return resetState();
      }
    });
  }
  render() {
    const {
      disableWholeForm = false,
      isFixedStyles = false
    } = this.props;
    const classes = isFixedStyles ? fixedClasses : responsiveClasses;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.form,
      "data-block": "BillingAddress"
    }, /*#__PURE__*/React.createElement(FormRow, {
      isFixedStyles: isFixedStyles
    }, /*#__PURE__*/React.createElement(FormInput, {
      isFixedStyles: isFixedStyles,
      width: 50
    }, /*#__PURE__*/React.createElement(_Field, {
      component: StyledInput,
      className: classes.error,
      label: "First name*",
      placeholder: "First name*",
      name: "firstName",
      InputProps: {
        disableUnderline: true
      },
      isFixedStyles: isFixedStyles,
      dataInput: "FirstName",
      disabled: disableWholeForm,
      validate: [required, maxLength(30), minLength(2)]
    })), /*#__PURE__*/React.createElement(FormInput, {
      isFixedStyles: isFixedStyles,
      width: 50
    }, /*#__PURE__*/React.createElement(_Field, {
      component: StyledInput,
      className: classes.error,
      label: "Last name*",
      placeholder: "Last name*",
      name: "lastName",
      InputProps: {
        disableUnderline: true
      },
      isFixedStyles: isFixedStyles,
      dataInput: "LastName",
      disabled: disableWholeForm,
      validate: [required, maxLength(30), minLength(2)]
    }))), /*#__PURE__*/React.createElement(FormRow, {
      isFixedStyles: isFixedStyles
    }, /*#__PURE__*/React.createElement(FormInput, {
      isFixedStyles: isFixedStyles,
      width: 58
    }, /*#__PURE__*/React.createElement(_Field, {
      component: StyledInput,
      className: classes.error,
      label: "Street*",
      placeholder: "Street*",
      name: "street",
      InputProps: {
        disableUnderline: true
      },
      isFixedStyles: isFixedStyles,
      dataInput: "Street",
      disabled: disableWholeForm,
      validate: [required, maxLength(60), minLength(3)]
    })), /*#__PURE__*/React.createElement(FormInput, {
      isFixedStyles: isFixedStyles,
      width: 42
    }, /*#__PURE__*/React.createElement(_Field, {
      component: StyledInput,
      className: classes.error,
      label: "Unit",
      placeholder: "Unit",
      name: "unit",
      InputProps: {
        disableUnderline: true
      },
      isFixedStyles: isFixedStyles,
      dataInput: "Unit",
      disabled: disableWholeForm,
      validate: [maxLength(50)]
    }))), /*#__PURE__*/React.createElement(FormRow, {
      isFixedStyles: isFixedStyles
    }, /*#__PURE__*/React.createElement(FormInput, {
      isFixedStyles: isFixedStyles,
      width: 66
    }, /*#__PURE__*/React.createElement(_Field, {
      component: StyledInput,
      className: classes.error,
      label: "City*",
      placeholder: "City*",
      name: "city",
      InputProps: {
        disableUnderline: true
      },
      isFixedStyles: isFixedStyles,
      dataInput: "City",
      disabled: disableWholeForm,
      validate: [required, maxLength(50), minLength(2)]
    })), /*#__PURE__*/React.createElement(FormInput, {
      isFixedStyles: isFixedStyles,
      width: 34
    }, /*#__PURE__*/React.createElement(_Field, {
      component: FormStatePicker,
      label: "State/Region",
      placeholder: "State/Region",
      name: "state",
      dataInput: "StateRegion",
      InputProps: {
        disableUnderline: true
      },
      isFixedStyles: isFixedStyles,
      disabled: disableWholeForm,
      validate: [maxLength(50), minLength(2)]
    }))), /*#__PURE__*/React.createElement(FormRow, {
      isFixedStyles: isFixedStyles
    }, /*#__PURE__*/React.createElement(FormInput, {
      isFixedStyles: isFixedStyles,
      width: 58
    }, /*#__PURE__*/React.createElement(_Field, {
      component: FormCountryPicker,
      label: "United States",
      placeholder: "United States",
      name: "country",
      onChange: this.handleCountryChange,
      dataInput: "Country",
      isFixedStyles: isFixedStyles,
      disabled: disableWholeForm,
      validate: [required]
    })), /*#__PURE__*/React.createElement(FormInput, {
      isFixedStyles: isFixedStyles,
      width: 42
    }, /*#__PURE__*/React.createElement(_Field, {
      component: StyledInput,
      className: classes.error,
      label: "Zip/Postal Code*",
      placeholder: "Zip/Postal Code*",
      type: "text",
      name: "zipcode",
      InputProps: {
        disableUnderline: true
      },
      isFixedStyles: isFixedStyles,
      dataInput: "Zipcode",
      disabled: disableWholeForm,
      validate: [required, maxLength(20), minLength(3)]
    }))));
  }
}